declare const environmentName: string;

const env: string = environmentName;
export { env as environmentName };






// WEBPACK FOOTER //
// ./src/globals.ts